import { formatUsdValue, roundToTwo } from '@/utils/helpers';

export default {
  props: {
    feePercent: {
      type: Number,
      default: 0,
    },
    feeCap: {
      type: Number,
      default: null,
    },
    isTransfer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasFee() {
      return Number(this.feePercent) > 0;
    },
    feePercentDisplay() {
      return roundToTwo(Number(this.feePercent) * 100);
    },
    feeCapDisplay() {
      return formatUsdValue(this.feeCap, { trimWhole: true });
    },
    hasFeeCap() {
      return this.hasFee && this.feeCap !== null && typeof this.feeCap !== 'undefined';
    },
    introText() {
      return this.isTransfer
        ? 'We remit transfer withdrawals via ACH only to verified account holders with US bank accounts.'
        : 'We remit funds via ACH only to verified account holders with US bank accounts.';
    },
    subjectText() {
      return this.isTransfer ? 'Transfer withdrawals' : 'Withdrawals';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/shared/withdraw-ach-disclaimer/withdraw-ach-disclaimer.js